export default "__VITE_ASSET__CCDE8hH9__"